import React from 'react';
import { Link } from 'react-router-dom';
import NotificationBell from '../../components/NotificationBell';

const StaffNavbar = () => {
  return (
    <header className="sticky top-0 z-40 bg-white shadow-sm">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3">
          <img src="/logo-bbts.png" alt="BBTS Logo" className="h-9 w-auto" />
          <span className="text-base font-semibold text-gray-800 sm:text-lg">
            Panel del Equipo
          </span>
        </Link>
        <nav className="flex items-center gap-2 text-sm font-medium text-gray-600">
          <NotificationBell />
          <Link
            to="/staff/profile"
            className="rounded-full border border-gray-200 px-4 py-2 hover:bg-orange-50"
          >
            Mi perfil
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default StaffNavbar;
